// Randomness helpers: crypto-quality for readings, seeded for "of the day".

export function randomInt(max) {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0] % max;
}

export function shuffle(list, rand = randomInt) {
  const a = [...list];
  for (let i = a.length - 1; i > 0; i--) {
    const j = rand(i + 1);
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// mulberry32 — small deterministic generator
function mulberry32(seed) {
  return () => {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

// one personal seed per visitor, so "card of the day" differs between people
function visitorId() {
  try {
    let id = localStorage.getItem('lunara-visitor');
    if (!id) {
      id = String(randomInt(1e9));
      localStorage.setItem('lunara-visitor', id);
    }
    return id;
  } catch {
    return 'guest';
  }
}

export function todayKey(date = new Date()) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

// same result all day for this visitor
export function dailyRandom(salt) {
  const rnd = mulberry32(hash(`${todayKey()}|${visitorId()}|${salt}`));
  return max => Math.floor(rnd() * max);
}
